import { createSelector } from 'reselect';
import {
  prop,
  pipe,
  values,
  pluck,
  head,
  keys,
  filter,
  includes,
  join,
  isNil,
  sort,
  reject,
  ifElse,
  gt,
  propSatisfies,
  either,
  isEmpty,
  __,
} from 'ramda';
import { selectFilterList } from '../filters';
import { selectCategories } from '../contentRegistry';

export const selectFilteredDomain = prop('filtered');

export const selectIsFetching = createSelector(
  selectFilteredDomain,
  prop('isFetching')
);

export const selectIsListenerActive = createSelector(
  selectFilteredDomain,
  prop('isListenerActive')
);

export const selectFilteredExperiences = createSelector(
  selectFilteredDomain,
  prop('filteredExperiences')
);

export const selectFilteredTitle = createSelector(
  selectFilterList,
  selectCategories,
  (filterList, categories) => {
    const {
      location: { data: locationFilterData },
      activities: { data: activitiesFilterData },
    } = filterList;
    const activitiesIds = keys(activitiesFilterData);

    const marketName = pipe(
      values,
      pluck('name'),
      head
    )(locationFilterData);

    const getSelectedActivities = filter(category => includes(prop('id', category), activitiesIds));

    const activityNames = pipe(
      values,
      getSelectedActivities,
      pluck('name'),
      sort((a, b) => a.localeCompare(b)),
      join(', ')
    )(categories);

    return pipe(
      reject(either(isNil, isEmpty)),
      ifElse(propSatisfies(gt(__, 1), 'length'), join(' - '), join(''))
    )([activityNames, marketName]);
  }
);
